"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentHeader = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var mediaQueries_1 = require("../../helpers/mediaQueries");
var ContentHeader = function (props) {
    var tabs = props.tabs, title = props.title, subTitle = props.subTitle, className = props.className;
    return (react_1.default.createElement(Wrapper, { className: className },
        react_1.default.createElement(Title, null, title),
        react_1.default.createElement(ClearLeft, null),
        subTitle,
        react_1.default.createElement(ClearLeft, { hidden: !subTitle }),
        tabs,
        react_1.default.createElement(ClearLeft, null)));
};
exports.ContentHeader = ContentHeader;
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding-top: 15px;\n"], ["\n  padding-top: 15px;\n"])));
var Title = styled_components_1.default.h2(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 1.4rem;\n  margin-bottom: 24px;\n  font-weight: 300;\n  text-transform: capitalize;\n\n  @media ", " {\n    font-size: 2.15rem;\n  }\n"], ["\n  font-size: 1.4rem;\n  margin-bottom: 24px;\n  font-weight: 300;\n  text-transform: capitalize;\n\n  @media ", " {\n    font-size: 2.15rem;\n  }\n"])), mediaQueries_1.TABLET_PORTRAIT);
var ClearLeft = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  clear: left;\n"], ["\n  clear: left;\n"])));
var templateObject_1, templateObject_2, templateObject_3;
